import * as React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';

/**
 * GRID SVG component
 *
 * @returns
 */
function GridSVG({ className }: SVGProps) {
	return (
		<svg
			viewBox="0 0 576 576"
			className={classnames('roc-icon roc-grid', className)}
			focusable="false"
			aria-hidden="true"
		>
			<path d="M352 0.001h192c17.673 0 32 14.327 32 32v192c0 17.673-14.327 32-32 32h-192c-17.673 0-32-14.327-32-32v-192c0-17.673 14.327-32 32-32z"></path>
			<path d="M32.001 320h192c17.673 0 32 14.327 32 32v192c0 17.673-14.327 32-32 32h-192c-17.673 0-32-14.327-32-32v-192c0-17.673 14.327-32 32-32z"></path>
			<path d="M352 320h192c17.673 0 32 14.327 32 32v192c0 17.673-14.327 32-32 32h-192c-17.673 0-32-14.327-32-32v-192c0-17.673 14.327-32 32-32z"></path>
			<path d="M32.001 0.001h192c17.673 0 32 14.327 32 32v192c0 17.673-14.327 32-32 32h-192c-17.673 0-32-14.327-32-32v-192c0-17.673 14.327-32 32-32z"></path>
		</svg>
	);
}

export default GridSVG;
